import TaskEvent from '../../event/TaskEvent'
import AppDispatcher from '../../core/AppDispatcher'

const onInit = () => {
  AppDispatcher.dispatchWithType(TaskEvent.initialize)
}

export default onInit
